/**
 * App footer rendered at the bottom of every page (including inside the
 * Capacitor APK shell). Carries About + Privacy links, trademark, and
 * copyright. Convention is to keep policy / secondary navigation here
 * rather than in the top nav.
 *
 * Kept deliberately spartan so it doesn't compete with page content.
 */
export function AppFooter() {
  return (
    <footer className="app-footer">
      <nav className="app-footer-links" aria-label="Secondary">
        <a href="/about">About</a>
        <a href="/privacy">Privacy</a>
      </nav>
      <div className="app-footer-legal">
        <span>joltstream&trade; is a trade mark of Time Back Solutions Ltd.</span>{' '}
        <span>&copy; 2026 Time Back Solutions Ltd. All rights reserved.</span>
      </div>
    </footer>
  );
}
